export default __webpack_public_path__ + "static/succeed-e7105bb0333b55435af39045a22b1599.jpg";